import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'

const getMapApiKey = () =>
  getRequest<{ googleMapsApiKey: string }>('/maps/key').then((res) => {
    if (!res) {
      throw new Error('Response is undefined')
    }
    return res.googleMapsApiKey
  })

export const useMapApiKey = () =>
  useSuspenseQuery({ queryKey: ['maps/key'], queryFn: getMapApiKey, staleTime: Infinity })
